// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"rFB-P","itemDetailFooter":"Cy-pX","itemDetailFooter-quantity":"EeVwh","itemDetailFooter-button":"_1Hsdo"};